import { render, staticRenderFns } from "./s-label.vue?vue&type=template&id=1251eeac&"
import script from "./s-label.vue?vue&type=script&lang=js&"
export * from "./s-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1251eeac')) {
      api.createRecord('1251eeac', component.options)
    } else {
      api.reload('1251eeac', component.options)
    }
    module.hot.accept("./s-label.vue?vue&type=template&id=1251eeac&", function () {
      api.rerender('1251eeac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-components/s-label/s-label.vue"
export default component.exports